






import {Component, Vue} from 'vue-property-decorator';
import {EventBus} from "@/helpers/EventBus";
import {PageName} from "@/configuration/pages";
import {Inject} from "vue-typedi";
import {DriveService} from "@/services/DriveService";
import {Drive} from "@/model/Drive";

@Component
export default class App extends Vue {
  @Inject()
  driveService!: DriveService;

  created() {
    EventBus.$on(EventBus.REFRESH_STORE_ID, (pageName: PageName) => {
      this.driveService.getDrivesByStoreId(sessionStorage.getItem("storeId"))
        .then((drives: Drive[]) => {
          sessionStorage.setItem("storeDrives", JSON.stringify(drives));
        })
        .finally(() => {
          return Promise.resolve();
        })
        .then(() => {
          if (pageName != null) {
            this.$router.push({name: pageName});
            return;
          }
        })
    })
  }
}
